import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

const ListPage = lazy(() => import('@/features/vacancies/list/page'));
const CreatePage = lazy(() => import('@/features/vacancies/create/page'));
const InfoPage = lazy(() => import('@/features/vacancies/info/page'));

// JobOpportunity.md uses `/job_opportunities/*` URLs. Relay keeps
// `/vacancies/*` as the canonical path and redirects the spec URLs
// so old bookmarks + cross-module links continue to resolve.
export const vacanciesRoutes: RouteObject[] = [
  { path: 'vacancies', element: <ListPage /> },
  { path: 'vacancies/new', element: <CreatePage /> },
  { path: 'vacancies/:id', element: <InfoPage /> },
  { path: 'job_opportunities', element: <Navigate to="/vacancies" replace /> },
  { path: 'job_opportunities/list', element: <Navigate to="/vacancies" replace /> },
  { path: 'job_opportunities/info', element: <Navigate to="/vacancies/new" replace /> },
];
